var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.01598 5.49998C4.27356 5.49998 3.89761 6.3976 4.42258 6.92257L7.41074 9.91075C7.73618 10.2362 8.26382 10.2362 8.58926 9.91075L11.5774 6.92257C12.1024 6.3976 11.7296 5.49998 10.9872 5.49998C7.64331 5.49998 7.94562 5.49998 5.01598 5.49998Z",
    fill: "#8A90A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectArrow);
export default __webpack_public_path__ + "static/media/select-arrow.0af6e3399a8cce6bbf7d344a4230cd61.svg";
export { ForwardRef as ReactComponent };